import { vue } from '@/main';

// Filter keys that expose affiliate data — same gate as the affiliate columns
// (CLIENT_READ_AFFILIATE). Campaign is deliberately NOT here.
export const AFFILIATE_FILTER_KEYS = ['affiliateId', 'hasAffiliate', 'banner', 'tag', 'affiliateSource', 'affiliateTokenId'];

export default function () {
  return [
    // Date-only pickers: the table expands a picked range to full days
    // (start of the from-day → end of the until-day) before requesting.
    {
      key: 'creationTime',
      type: 'dateRange',
      props: { mode: 'date' }
    },
    {
      key: 'ftdTime',
      type: 'dateRange',
      props: { mode: 'date' }
    },

    { key: 'id' },
    { key: 'firstName' }, { key: 'lastName' }, { key: 'phone' }, { key: 'email' }, { key: 'account' },
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'buTypes',
      label: 'departments',
      type: 'department',
      props: {
        clearable: true,
        multiple: true
      }
    },

    {
      key: 'statusList',
      type: 'status',
      props: {}
    },
    // Campaign: free text set by the affiliate API / excel import (not a known
    // list) → wildcard text filter. Visible to every role (explicit user decision).
    { key: 'campaign' },
    // Affiliate filters — only for CLIENT_READ_AFFILIATE (see AFFILIATE_FILTER_KEYS;
    // the backend ignores them without the permission too).
    {
      key: 'affiliateId',
      type: 'affiliate',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'hasAffiliate',
      type: 'select',
      props: {
        options: [
          { value: true, label: vue.$t('filters.withAffiliate') },
          { value: false, label: vue.$t('filters.withoutAffiliate') },
        ],
        reduce: option => option.value,
        clearable: true,
        multiple: false,
      }
    },
    { key: 'banner' },
    { key: 'tag' },
    { key: 'affiliateSource' },
    {
      key: 'affiliateTokenId',
      type: 'tags',
      props: { size: 'sm' }
    },
    {
      key: 'representativeUserIds',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
        nullable: true
      }
    },
    {
      key: 'ftdOwnerIds',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
        nullable: true
      }
    },
    {
      key: 'online',
      type: 'checkbox'
    },
    {
      key: 'marginCall',
      type: 'checkbox'
    },
    {
      key: 'vip',
      type: 'checkbox'
    }
  ];
}
